<template>
  <div>
    <div class="container mb-20">
      <div v-if="event && event.categories.length">
        <h2 class="text-black font-semibold text-2xl py-8 text-center">Tickets auswählen</h2>

        <div class="border rounded-xl overflow-hidden">
          <template v-for="category in event.categories">
            <div :key="category.id" v-if="category.types.length">
              <h3 class="md:text-lg font-semibold text-green-700 bg-gray-100 px-6 py-5">
                {{ category.title }}
              </h3>
              <ul class="bg-white">
                <li
                  v-for="ticket in category.types"
                  :key="ticket.id"
                  class="flex items-center justify-between py-4 md:px-8 px-4"
                  :class="{ 'bg-green-100': items[ticket.id] }"
                >
                  <div class="md:w-1/4 w-2/3">
                    <h3 class="font-medium md:text-lg">{{ ticket.title }}</h3>

                    <p class="text-gray-500 md:text-orig text-sm">{{ ticket.description }}</p>
                    <div class="md:hidden block mt-2">
                      <span class="text-xl font-medium">{{
                        (ticket.price_including_fees / 100) | price
                      }}</span>
                    </div>
                  </div>
                  <div class="md:inline-block hidden">
                    <span class="text-2xl font-medium">{{
                      (ticket.price_including_fees / 100) | price
                    }}</span>
                  </div>
                  <div class="md:w-1/4 md:flex md:justify-end self-start md:self-auto">
                    <div class="relative">
                      <div v-if="ticket.max_amount_per_order <= 0 && !ticket.marks_sold_out">
                        <span
                          class="text-xs md:text-sm whitespace-no-wrap text-yellow-700 bg-yellow-300 rounded px-2 self-start"
                          >Zur Zeit nicht Verfügbar</span
                        >
                      </div>
                      <div v-else-if="ticket.max_amount_per_order <= 0 && ticket.marks_sold_out">
                        <span
                          class="text-xs md:text-sm whitespace-no-wrap text-red-700 bg-red-300 rounded px-2 self-start"
                          >Ausverkauft</span
                        >
                      </div>
                      <select
                        v-else
                        class="form-select block rounded-full"
                        :class="{
                          'bg-green-100 border-green-600 focus:border-green-600 text-green-600 font-medium fill-current':
                            items[ticket.id],
                        }"
                        @change="selectTicket($event, ticket)"
                      >
                        <template>
                          <option value="0">0</option>
                          <template
                            v-for="qty in range(
                              ticket.min_amount_per_order,
                              ticket.max_amount_per_order
                            )"
                          >
                            <option
                              :value="qty"
                              :key="qty"
                              :selected="
                                items[ticket.id]
                                  ? items[ticket.id].qty === qty
                                    ? 'selected'
                                    : ''
                                  : ''
                              "
                            >
                              {{ qty }}
                            </option>
                          </template>
                        </template>
                      </select>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _forEach from 'lodash/forEach';
import _times from 'lodash/times';

export default {
  props: ['event'],

  data() {
    return {
      items: {},
    };
  },

  filters: {
    price(value) {
      var formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      });

      return formatter.format(value);
    },
  },

  methods: {
    selectTicket(e, ticket) {
      if (parseInt(e.target.value) === 0) {
        this.removeCartItem(ticket);
      } else {
        this.updateCartItem(ticket, parseInt(e.target.value));
      }

      this.emitSelected();
    },

    updateCartItem(item, qty) {
      let cartItem = {
        ...item,
        qty: qty,
      };

      this.addCartItem(cartItem);
    },

    addCartItem(item) {
      this.$set(this.items, item.id, item);
    },

    removeCartItem(item) {
      this.$delete(this.items, item.id);
    },

    emitSelected() {
      let tickets = [];

      _forEach(this.items, (item) => {
        _times(item.qty, () => {
          tickets.push({
            type_id: item.id,
            price: item.price_including_fees,
          });
        });
      });

      this.$emit('updated', tickets);
    },

    range(min, max) {
      var array = [];
      var j = 0;
      for (var i = min; i <= max; i++) {
        array[j] = i;
        j++;
      }
      return array;
    },
  },
};
</script>